//last app.js
import React, {
  useState,
  useEffect,
  useRef,
} from "react";

import "./App.css";

import logo from "./assets/vedai.png";

import { signInWithPopup, signOut, onAuthStateChanged } from "firebase/auth";
import { auth, provider, db } from "./firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import CareerAI from "./pages/CareerAI";
import PlansPage from "./pages/PlansPage";

import FriendsAI from "./pages/FriendsAI";

import LiveSingCoach from "./pages/LiveSingCoach";

import PaymentSuccess from "./PaymentSuccess";

import {
  BrowserRouter,
  Routes,
  Route,
  Link,
} from "react-router-dom";

function App() {

  // ==========================
  // USER
  // ==========================
  const [user, setUser] =
    useState(null);

  // ==========================
  // CHAT
  // ==========================
  const [message, setMessage] =
    useState("");

  const [messages, setMessages] =
    useState([
      {
        role: "assistant",
        content:
          "Hello 👋 I am VedAI. How can I help you today?",
      },
    ]);

  const [loading, setLoading] =
    useState(false);

  const [listening, setListening] =
  useState(false);

  // ==========================
  // PLAN
  // ==========================
  const [planInfo, setPlanInfo] =
    useState(null);

  // ==========================
  // IMAGE GENERATION
  // ==========================
  const [imagePrompt, setImagePrompt] =
    useState("");

  const [
    generatedImage,
    setGeneratedImage,
  ] = useState("");

  const [
    imageLoading,
    setImageLoading,
  ] = useState(false);

  // ==========================
// SINGER AI REVIEW
// ==========================
const [songLink, setSongLink] =
  useState("");

const [reviewLoading, setReviewLoading] =
  useState(false);

const [reviewResult, setReviewResult] =
  useState("");

// ==========================
// HEALTH REPORT AI
// ==========================
const [healthFile, setHealthFile] =
  useState(null);

const [healthLoading, setHealthLoading] =
  useState(false);

const [healthResult, setHealthResult] =
  useState("");

const [selectedLanguage, setSelectedLanguage] =
  useState("English");

const [showMemory, setShowMemory] = useState(false);
const [memoryList, setMemoryList] = useState([]);

const [activeTab, setActiveTab] = useState("chat");

const [visionFile, setVisionFile] = useState(null);
const [visionResult, setVisionResult] = useState("");

const [facingMode, setFacingMode] = useState("environment");

const [rotation, setRotation] = useState(0);

const startCamera = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: facingMode
      }
    });

    if (videoRef.current) {
      videoRef.current.srcObject = stream;
    }

    setCameraOn(true);

  } catch (error) {
    console.log("CAMERA ERROR:", error);
  }
};

const stopCamera = () => {
  const stream = videoRef.current?.srcObject;

  if (stream) {
    stream.getTracks().forEach(track => track.stop());
  }

  setCameraOn(false);
};

const captureFrame = () => {
  const video = videoRef.current;
  const canvas = canvasRef.current;

  if (!video || !canvas) {
    console.log("Missing video or canvas");
    return null;
  }

  if (video.videoWidth === 0) {
    console.log("Video not ready");
    return null;
  }

  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;

  const ctx = canvas.getContext("2d");
  ctx.drawImage(video, 0, 0);

  const imageData = canvas.toDataURL("image/jpeg");

  console.log("Frame captured");

  return imageData;
};

const askCamera = async () => {
  const frame = captureFrame();

  if (!frame) {
    alert("Camera frame not available");
    return;
  }

  if (!cameraQuestion.trim()) {
    alert("Ask something about camera first");
    return;
  }

  setVisionResult("Analyzing...");

  try {

console.log("FRAME LENGTH:", frame?.length);
console.log("FRAME START:", frame?.substring(0, 50));

    const response = await fetch("/api/vision", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
  image: frame,
  userId: user.uid,
  question: cameraQuestion,
  language: selectedLanguage,
}),
    });

    const data = await response.json();

    if (data.success) {
      setVisionResult(data.reply);
    } else {
      setVisionResult("Vision failed");
    }

  } catch (err) {
    console.log("VISION ERROR:", err);
    setVisionResult("Server error");
  }
};

const startCameraVoice = () => {

// ==========================
// CAMERA VOICE LIMIT
// ==========================
if (planInfo) {

  let limit = 1;

  if (planInfo.plan === "PRO") {
    limit = 3;
  }

  if (planInfo.plan === "ULTRA") {
    limit = 10;
  }

  const used =
    planInfo.cameraVoiceUsed || 0;

  if (used >= limit) {

    alert(
      "Daily camera voice limit reached."
    );

    return;
  }
}

  const SpeechRecognition =
    window.SpeechRecognition ||
    window.webkitSpeechRecognition;

  if (!SpeechRecognition) {

    alert(
      "Speech recognition not supported in this browser."
    );

    return;
  }

  const recognition =
    new SpeechRecognition();

  recognition.lang =
  getSpeechLanguage();

  recognition.continuous = false;

  recognition.interimResults = false;

  recognition.start();

  recognition.onresult = async (event) => {

    const transcript =
      event.results[0][0].transcript;

    setCameraQuestion(transcript);

    const frame = captureFrame();

    if (!frame) {
      alert("Camera frame not available");
      return;
    }

    setVisionResult(
      "Analyzing..."
    );

    try {

      const response =
        await fetch(
          "/api/vision",
          {
            method: "POST",

            headers: {
              "Content-Type":
                "application/json",
            },

            body: JSON.stringify({
              image:
                frame.split(",")[1],

              userId:
                user.uid,

              question:
                transcript,

              language:
                selectedLanguage,
            }),
          }
        );

      const data =
        await response.json();

console.log("VISION RESPONSE:");
console.log(data);

      if (data.success) {

  setVisionResult(
    data.reply
  );

  setPlanInfo((prev) => ({
    ...prev,
    cameraVoiceUsed:
      (prev?.cameraVoiceUsed || 0) + 1,
  }));

  speakText(
    data.reply
  );

}

    } catch (error) {

      console.log(
        "VOICE CAMERA ERROR:",
        error
      );

    }

  };

};

const [visionLoading, setVisionLoading] = useState(false);
const [cameraOn, setCameraOn] = useState(false);
const [cameraQuestion, setCameraQuestion] = useState("");

const loadMemory = async () => {
  if (!user?.uid) return;

  try {
    const res = await fetch(`/api/get-memory/${user.uid}`);
    const data = await res.json();

    console.log("🧠 MEMORY API:", data);

    if (data.success && Array.isArray(data.memories)) {
      setMemoryList(data.memories);
    } else {
      setMemoryList([]);
    }

  } catch (err) {
    console.log("Memory load error:", err);
    setMemoryList([]);
  }
};

const getSpeechLanguage = () => {

  switch (selectedLanguage) {

    case "Hindi":
      return "hi-IN";

    case "Gujarati":
      return "gu-IN";

    case "Marathi":
      return "mr-IN";

    case "Tamil":
      return "ta-IN";

    case "Telugu":
      return "te-IN";

    case "Bengali":
      return "bn-IN";

    case "Punjabi":
      return "pa-IN";

    case "Kannada":
      return "kn-IN";

    case "Malayalam":
      return "ml-IN";

    case "Odia":
      return "or-IN";

    default:
      return "en-US";

  }

};


  // ==========================
  // AUTO SCROLL
  // ==========================
  const messagesEndRef =
    useRef(null);

  const videoRef = useRef(null);

  const canvasRef = useRef(null);

  // ==========================
  // AUTH STATE
  // ==========================
  useEffect(() => {

    const unsubscribe =
      onAuthStateChanged(
        auth,
        (currentUser) => {

          console.log(
            "🔥 AUTH STATE CHANGED:",
            currentUser
          );

          setUser(currentUser);
        }
      );

    return () => unsubscribe();

  }, []);

  // ==========================
  // FETCH PLAN INFO
  // ==========================
  useEffect(() => {

    if (!user) return;

    const fetchPlan =
      async () => {

        try {

          const res =
            await fetch(
              "/api/ai-usage",
              {
                method: "POST",

                headers: {
                  "Content-Type":
                    "application/json",
                },

                body: JSON.stringify({
                  userId:
                    user.uid,
                }),
              }
            );

          const data =
            await res.json();

          if (data.success) {
            setPlanInfo(data);
          }

        } catch (err) {

          console.log(
            "PLAN FETCH ERROR:",
            err
          );

        }

      };

    fetchPlan();

  }, [user]);

  // ==========================
  // AUTO SCROLL
  // ==========================
  useEffect(() => {

    messagesEndRef.current?.scrollIntoView(
      {
        behavior: "smooth",
      }
    );

  }, [messages]);

  // ==========================
  // LOGIN
  // ==========================
  const handleGoogleLogin = async () => {
  try {
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    console.log("🔥 LOGIN SUCCESS:", user.uid);

    const userRef = doc(db, "vedai_users", user.uid);
    const snap = await getDoc(userRef);

    if (!snap.exists()) {
      console.log("🔥 CREATING FIREBASE DOCUMENT...");

      await setDoc(userRef, {
        uid: user.uid,
        name: user.displayName || "",
        email: user.email || "",
        plan: "FREE",
        createdAt: new Date(),
      });

      console.log("✅ FIREBASE USER CREATED");
    } else {
      console.log("ℹ️ USER ALREADY EXISTS");
    }

    setUser(user);

  } catch (error) {
    console.log("LOGIN ERROR:", error);
  }
};

  // ==========================
  // LOGOUT
  // ==========================
  const handleLogout =
    async () => {

      await signOut(auth);

      setPlanInfo(null);

    };

  // ==========================
  // REFRESH PLAN INFO
  // ==========================
  const refreshPlanInfo =
    async () => {

      if (!user) return;

      try {

        const usageRes =
          await fetch(
            "/api/ai-usage",
            {
              method: "POST",

              headers: {
                "Content-Type":
                  "application/json",
              },

              body: JSON.stringify({
                userId:
                  user.uid,
              }),
            }
          );

        const usageData =
          await usageRes.json();

        if (
          usageData.success
        ) {
          setPlanInfo(
            usageData
          );
        }

      } catch (e) {

        console.log(
          "USAGE REFRESH ERROR:",
          e
        );

      }

    };

  // ==========================
// SPEECH TO TEXT
// ==========================
const startListening = () => {

  const SpeechRecognition =
    window.SpeechRecognition ||
    window.webkitSpeechRecognition;

  if (!SpeechRecognition) {

    alert(
      "Speech recognition not supported in this browser."
    );

    return;

  }

  const recognition =
    new SpeechRecognition();

  recognition.lang =
  getSpeechLanguage();

  recognition.continuous = false;

  recognition.interimResults = false;

  recognition.start();

  setListening(true);

  recognition.onresult = (event) => {

    const transcript =
      event.results[0][0].transcript;

    setMessage(transcript);

  };

  recognition.onerror = (event) => {

    console.log(
      "Speech Error:",
      event.error
    );

    setListening(false);

  };

  recognition.onend = () => {

    setListening(false);

  };

};

  // ==========================
// SPEAK RESPONSE
// ==========================
const speakText = (text, plan = "free") => {
  if (!text) return;

  // ULTRA plan → handled by ElevenLabs (skip browser)
  if (plan === "ultra") return;

  const speech = new SpeechSynthesisUtterance(text);

  const voices = window.speechSynthesis.getVoices();

  // SMART INDIAN LANGUAGE PRIORITY
  const voice =
    voices.find(v => v.lang.includes("hi")) ||   // Hindi
    voices.find(v => v.lang.includes("ta")) ||   // Tamil
    voices.find(v => v.lang.includes("en")) ||  // English
    voices[0];

  if (voice) {
    speech.voice = voice;
    speech.lang = voice.lang;
  }

  speech.rate = 1;
  speech.pitch = 1;
  speech.volume = 1;

  window.speechSynthesis.cancel();
  window.speechSynthesis.speak(speech);
};

  // ==========================
  // SEND MESSAGE
  // ==========================
  const sendMessage =
    async () => {

      if (
        !message.trim()
      ) {
        return;
      }

      // ==========================
      // LOGIN REQUIRED
      // ==========================
      if (
        !user ||
        !user.uid
      ) {

        alert(
          "Please login first to use VedAI"
        );

        return;
      }

      const currentMessage =
        message;

      // ==========================
      // ADD USER MESSAGE
      // ==========================
      setMessages(
        (prev) => [
          ...prev,

          {
            role: "user",

            content:
              currentMessage,
          },
        ]
      );

      setMessage("");

      setLoading(true);

      try {

        const response =
          await fetch(
            "/api/ai-reply",
            {
              method: "POST",

              headers: {
                "Content-Type":
                  "application/json",
              },

              body: JSON.stringify(
                {
                  message:
                    currentMessage,

                  userId:
                    user.uid,
                }
              ),
            }
          );

        // ==========================
        // LIMIT REACHED
        // ==========================
        if (
          response.status ===
          429
        ) {

          setMessages(
            (prev) => [
              ...prev,

              {
                role:
                  "assistant",

                content:
                  "🚫 Daily limit reached. Please upgrade your plan below.",
              },
            ]
          );

          setLoading(false);

          return;
        }

        const data =
          await response.json();

// ==========================
// SPEAK AI RESPONSE
// ==========================
if (data.audio) {
  const audio = new Audio(
    `data:audio/mp3;base64,${data.audio}`
  );
  audio.play();

} else if (data.reply) {
  speakText(data.reply, data.plan);
}

        // ==========================
        // ADD AI RESPONSE
        // ==========================
        setMessages(
          (prev) => [
            ...prev,

            {
              role:
                "assistant",

              content:
                data.reply ||
                data.error ||
                "No response from VedAI",
            },
          ]
        );

        // ==========================
        // REFRESH PLAN
        // ==========================
        await refreshPlanInfo();

      } catch (error) {

        console.log(
          "API Error:",
          error
        );

        setMessages(
          (prev) => [
            ...prev,

            {
              role:
                "assistant",

              content:
                "❌ Cannot connect to VedAI server.",
            },
          ]
        );

      }

      setLoading(false);

    };

   // ==========================
// SINGER AI REVIEW
// ==========================
const reviewSong =
  async () => {

    if (!songLink.trim()) {

      alert(
        "Please paste your YouTube, Smule or StarMaker song link."
      );

      return;
    }

    if (
      !user ||
      !user.uid
    ) {

      alert(
        "Please login first."
      );

      return;
    }

    // ==========================
// SONG REVIEW LIMITS
// ==========================
if (planInfo) {

  let limit = 1;

  if (
    planInfo.plan ===
    "PRO"
  ) {
    limit = 5;
  }

  if (
    planInfo.plan ===
    "ULTRA"
  ) {
    limit = 10;
  }

  const used =
    planInfo.songReviewsUsed || 0;

  if (used >= limit) {

    alert(
      "Daily song review limit reached."
    );

    return;

  }

}
    setReviewLoading(true);

    setReviewResult("");

    try {

      const response =
        await fetch(
          "/api/ai-reply",
          {
            method: "POST",

            headers: {
              "Content-Type":
                "application/json",
            },

            body: JSON.stringify({
              userId: user.uid,

              message:
`You are VedAI Singer Coach.

A user shared a singing performance link.

Even if you cannot directly open the link, NEVER say you cannot access the link.

Instead, behave like a professional singing mentor and give an intelligent realistic-style singing review.

Performance Link:
${songLink}

Give response in this format:

🎤 Voice Quality:
(2-3 lines)

🎵 Pitch Accuracy:
(2-3 lines)

⏱ Timing & Rhythm:
(2-3 lines)

❤️ Emotion & Expression:
(2-3 lines)

🌬 Breath Control:
(2-3 lines)

🗣 Pronunciation:
(2-3 lines)

🔥 Confidence & Stage Presence:
(2-3 lines)

⭐ Overall Rating:
Give rating out of 10.

🎯 Improvement Tips:
Give practical mentor-style tips.

Make the review feel personalized, motivating, realistic and professional.`,
            }),
          }
        );

      const data =
        await response.json();

      if (data.reply) {

        setReviewResult(
          data.reply
        );
        
  // ==========================
  // UPDATE SONG REVIEW COUNT
  // ==========================
  setPlanInfo((prev) => ({
    ...prev,
    songReviewsUsed:
      (prev.songReviewsUsed || 0) + 1,
  }));


        speakText(
          "Your singing review is ready."
        );

      }

    } catch (error) {

      console.log(
        "SONG REVIEW ERROR:",
        error
      );

      alert(
        "Review failed."
      );

    }

    setReviewLoading(false);

  };

// ==========================
// HEALTH REPORT ANALYZER
// ==========================
const analyzeHealthReport =
  async () => {

    if (!healthFile) {

      alert(
        "Please upload medical report."
      );

      return;
    }

    if (!user || !user.uid) {

      alert(
        "Please login first."
      );

      return;
    }

    setHealthLoading(true);

    setHealthResult("");

    try {

      const formData =
        new FormData();

      formData.append(
        "report",
        healthFile
      );

      formData.append(
        "userId",
        user.uid
      );

      formData.append(
  "language",
  selectedLanguage
);

      const response =
        await fetch(
          "/api/health-report",
          {
            method: "POST",
            body: formData,
          }
        );

      const data =
        await response.json();

      console.log(
        "HEALTH API RESPONSE:",
        data
      );

      if (
        data.success &&
        data.reply
      ) {

        let parsed;

        try {

          parsed =
            JSON.parse(
              data.reply
            );

        } catch {

          parsed = {
            summary:
              data.reply,
          };

        }

        let formatted =
          "";

        // ==========================
        // SUMMARY
        // ==========================
        formatted +=
`🩺 SUMMARY:

${parsed.summary || "N/A"}


`;

        // ==========================
        // POSSIBLE CONCERNS
        // ==========================
        formatted +=
`⚠️ POSSIBLE CONCERNS:

${
  parsed.possibleConcerns?.length
    ? parsed.possibleConcerns.join("\n")
    : "None"
}


`;

        // ==========================
        // ABNORMAL VALUES
        // ==========================
        formatted +=
`📊 ABNORMAL VALUES:

${
  parsed.abnormalValues?.length
    ? parsed.abnormalValues.join("\n")
    : "None"
}


`;

        // ==========================
        // DIET SUGGESTIONS
        // ==========================
        formatted +=
`🥗 DIET SUGGESTIONS:

${
  parsed.dietSuggestions?.length
    ? parsed.dietSuggestions.join("\n")
    : "No suggestions"
}


`;

        // ==========================
        // LIFESTYLE
        // ==========================
        formatted +=
`🏃 LIFESTYLE RECOMMENDATIONS:

${
  parsed.lifestyleRecommendations?.length
    ? parsed.lifestyleRecommendations.join("\n")
    : "No recommendations"
}


`;

        // ==========================
        // REMEDIES
        // ==========================
        formatted +=
`💊 BASIC REMEDIES:

${
  parsed.basicRemedies?.length
    ? parsed.basicRemedies.join("\n")
    : "No remedies"
}


`;

        // ==========================
        // DOCTOR ADVICE
        // ==========================
        formatted +=
`👨‍⚕️ DOCTOR ADVICE:

${parsed.doctorAdvice || "N/A"}


`;

        // ==========================
        // RISK LEVEL
        // ==========================
        formatted +=
`🚨 RISK LEVEL:

${parsed.riskLevel || "unknown"}


`;

        // ==========================
        // WARNING FLAGS
        // ==========================
        formatted +=
`🚩 WARNING FLAGS:

${
  parsed.warningFlags?.length
    ? parsed.warningFlags.join("\n")
    : "None"
}`;

        setHealthResult(
          formatted
        );

        speakText(
          "Health report analysis is ready."
        );

      } else {

        console.log(
          "HEALTH API FAILED:",
          data
        );

        alert(
          data.error ||
          "Health analysis failed."
        );

      }

    } catch (error) {

      console.log(
        "HEALTH REPORT ERROR:",
        error
      );

      alert(
        "Health report analysis failed."
      );

    }

    setHealthLoading(false);

  };

  // ==========================
// GENERATE IMAGE
// ==========================
const generateImage = async () => {

  if (!imagePrompt.trim()) {
    return;
  }

  if (!user || !user.uid) {
    alert("Please login first to generate images.");
    return;
  }

  setImageLoading(true);
  setGeneratedImage("");

  try {

    const response = await fetch("/api/generate-image", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        prompt: imagePrompt,
        userId: user.uid,
      }),
    });

    const data = await response.json();

    if (data.success && data.image) {
      setGeneratedImage(
        `data:image/png;base64,${data.image}`
      );
    }

  } catch (error) {
    console.log("IMAGE ERROR:", error);
    alert("Image generation failed.");
  }

  setImageLoading(false);
};


// ==========================
// 👁️ VEDAI VISION (EYES)
// ==========================
const analyzeImage = async () => {
  if (!visionFile) {
    alert("Please upload an image first");
    return;
  }

  if (!user || !user.uid) {
    alert("Please login first");
    return;
  }

  setVisionLoading(true);
  setVisionResult("");

  try {
    const reader = new FileReader();

    reader.onloadend = async () => {
      const base64 = reader.result.split(",")[1];

      const response = await fetch("/api/vision", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          image: base64,
          userId: user.uid,
          language: selectedLanguage,
        }),
      });

      const text = await response.text();

console.log("STATUS:", response.status);
console.log("VISION RAW RESPONSE:", text);

if (!response.ok) {
  throw new Error(text);
}

const data = JSON.parse(text);

      if (data.success) {
        setVisionResult(data.reply);
        speakText("Image analysis complete");
      } else {
        setVisionResult(data.error || "Vision failed");
      }

      setVisionLoading(false);
    };

    reader.readAsDataURL(visionFile);

  } catch (error) {
    console.log("VISION ERROR:", error);
    setVisionLoading(false);
    alert("Vision analysis failed");
  }
};

  return (



<BrowserRouter>

  <Routes>

    <Route
      path="/career-ai"
      element={<CareerAI />}
    />

    <Route path="/friends-ai" element={<FriendsAI />} />

    <Route path="/live-sing" element={<LiveSingCoach />} />

    <Route path="/payment-success" element={<PaymentSuccess />} />

    <Route path="/plans" element={<PlansPage />} />

    <Route
      path="/"
      element={

<div className="app">

      {/* SIDEBAR */}
      <div className="sidebar">

        <div>

          {/* LOGO */}
          <img
            src={logo}
            alt="VedAI"
            className="main-logo"
          />

          <h1 className="logo">
            VedAI
          </h1>

          <p className="tagline">
            Intelligent AI Assistant
          </p>

  <Link
  to="/career-ai"
  style={{
    textDecoration: "none",
  }}
>

  <button
    style={{
      marginTop: "20px",
      padding: "12px 20px",
      borderRadius: "10px",
      border: "none",
      background: "#2563eb",
      color: "white",
      cursor: "pointer",
      width: "100%",
      fontWeight: "bold",
    }}
  >
    🚀 Open Career AI
  </button>

</Link>

<Link
  to="/friends-ai"
  style={{ textDecoration: "none" }}
>
  <button
    style={{
      marginTop: "10px",
      padding: "12px 20px",
      borderRadius: "10px",
      border: "none",
      background: "#2563eb",
      color: "white",
      cursor: "pointer",
      width: "100%",
      fontWeight: "bold",
    }}
  >
    🤝 Open Friends AI
  </button>
</Link>

<Link to="/live-sing" className="feature-card">
<button
    style={{
      marginTop: "10px",
      padding: "12px 20px",
      borderRadius: "10px",
      border: "none",
      background: "#2563eb",
      color: "white",
      cursor: "pointer",
      width: "100%",
      fontWeight: "bold",
    }}
  >

  🎤 Live Singing Coach
  </button>
</Link>




          {/* USER PROFILE */}
          {user && (

            <div className="profile">

  <img
    src={user.photoURL}
    alt=""
    className="profile-img"
  />

  <div className="profile-info">
    
    <div className="profile-name">
      {user.displayName}
    </div>

    

    {/* PLAN BOX */}
    {planInfo && (
      <div className="plan-box">
        <div className="plan-title">Current Plan</div>

        <div className="plan-line">
          Plan: {planInfo.plan}
        </div>

        <div className="plan-line">
          Used: {planInfo.used}/{planInfo.limit}
        </div>

        <div className="plan-line">
          Remaining: {planInfo.remaining}
        </div>

        <div className="plan-line">
          Camera Voice: {planInfo.cameraVoiceUsed || 0}
        </div>
      </div>
    )}
              </div>

            </div>

          )}

        </div>

        <div>

         {/* LOGIN / LOGOUT */}
{!user ? (
  <button
    className="login-btn"
    onClick={handleGoogleLogin}
  >
    Sign in with Google
  </button>
) : (
  <>
    <button
      className="logout-btn"
      onClick={handleLogout}
    >
      Logout
    </button>

    {/* 💎 VIEW PLANS BUTTON */}
    <Link to="/plans" style={{ textDecoration: "none" }}>
      <button
        style={{
          marginTop: "10px",
          padding: "12px 20px",
          borderRadius: "10px",
          border: "none",
          background: "#f59e0b",
          color: "black",
          cursor: "pointer",
          width: "100%",
          fontWeight: "bold",
        }}
      >
        💎 View Plans
      </button>
    </Link>
  </>
)}

</div>   {/* ✅ sidebar closes here */}

</div>


{/* ================= MAIN ================= */}
            <div className="main">

              {/* ================= TOPBAR ================= */}
              <div className="topbar">

                <div className="topbar-title">VedAI Assistant</div>
                <div className="topbar-status">● Online</div>

                <div style={{ display: "flex", gap: "10px", margin: "10px 0" }}>
                  <button
                    onClick={() => setActiveTab("chat")}
                    style={{ background: activeTab === "chat" ? "#2563eb" : "#374151" }}
                  >
                    💬 Chat
                  </button>

                  <button
                    onClick={() => setActiveTab("tools")}
                    style={{ background: activeTab === "tools" ? "#2563eb" : "#374151" }}
                  >
                    🧰 Tools
                  </button>
                </div>

                <button
                  onClick={() => {
                    setShowMemory(true);
                    loadMemory();
                  }}
                >
                  🧠 Memory
                </button>

              </div>

{/* ================= TOOLS ================= */}
              {activeTab === "tools" && (
                <div className="tools-area">


{/* HEALTH REPORT AI */}
<div className="image-generator">

  <input
    type="file"
    accept=".jpg,.jpeg,.png,.pdf"
    onChange={(e) =>
      setHealthFile(
        e.target.files[0]
      )
    }
  />

  <select
  value={selectedLanguage}
  onChange={(e) =>
    setSelectedLanguage(
      e.target.value
    )
  }
  style={{
    width: "100%",
    padding: "14px",
    marginTop: "12px",
    marginBottom: "12px",
    borderRadius: "12px",
    border: "2px solid #00d4ff",
    background:
      "linear-gradient(135deg, #111827, #1f2937)",
    color: "#ffffff",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    outline: "none",
    boxShadow:
      "0 4px 15px rgba(0,212,255,0.25)"
  }}
>
  <option style={{ color: "#000" }}>
    English
  </option>
  <option style={{ color: "#000" }}>
    Hindi
  </option>
  <option style={{ color: "#000" }}>
    Gujarati
  </option>
  <option style={{ color: "#000" }}>
    Marathi
  </option>
  <option style={{ color: "#000" }}>
    Tamil
  </option>
  <option style={{ color: "#000" }}>
    Telugu
  </option>
  <option style={{ color: "#000" }}>
    Bengali
  </option>
  <option style={{ color: "#000" }}>
    Punjabi
  </option>
  <option style={{ color: "#000" }}>
    Assamese
  </option>
  <option style={{ color: "#000" }}>
    Sindhi
  </option>
  <option style={{ color: "#000" }}>
    Bhojpuri
  </option>
  <option style={{ color: "#000" }}>
    Malayalam
  </option>
  <option style={{ color: "#000" }}>
    Haryanvi
  </option>
  <option style={{ color: "#000" }}>
    Odia
  </option>
  <option style={{ color: "#000" }}>
    Kannada
  </option>
</select>

  <button
    onClick={
      analyzeHealthReport
    }
  >
    Analyze Health Report
  </button>

</div>

<div className="image-generator">

  <input
    type="file"
    accept="image/*"
    onChange={(e) => setVisionFile(e.target.files[0])}
  />

  <button onClick={analyzeImage}>
    Analyze Image (Eyes AI)
  </button>

</div>

{visionLoading && (
  <div className="image-loading">
    VedAI is looking at the image...
  </div>
)}

{visionResult && (
  <div className="message ai">
    {visionResult}
  </div>
)}

{/* HEALTH LOADING */}
{healthLoading && (

  <div className="image-loading">
    VedAI is analyzing medical report...
  </div>

)}

{/* HEALTH RESULT */}
{healthResult && (

  <div className="message ai">
    {healthResult}
  </div>

)}

{/* SINGER AI REVIEW */}
<div className="image-generator">

  <input
    type="text"
    placeholder="Paste your YouTube, Smule or StarMaker song link..."
    value={songLink}
    onChange={(e) =>
      setSongLink(
        e.target.value
      )
    }
  />

  <button
    onClick={reviewSong}
  >
    Review Singing
  </button>

</div>

{/* REVIEW LOADING */}
{reviewLoading && (

  <div className="image-loading">
    VedAI is analyzing singing...
  </div>

)}

{/* REVIEW RESULT */}
{reviewResult && (

  <div className="message ai">
    {reviewResult}
  </div>

)}

        {/* IMAGE GENERATOR */}
        <div className="image-generator">

          <input
            type="text"
            placeholder="Create AI image..."
            value={
              imagePrompt
            }
            onChange={(e) =>
              setImagePrompt(
                e.target.value
              )
            }
          />

          <button
            onClick={
              generateImage
            }
          >
            Generate Image
          </button>

        </div>

        {/* IMAGE LOADING */}
        {imageLoading && (

          <div className="image-loading">
            Generating image...
          </div>

        )}

       {/* GENERATED IMAGE */}
{generatedImage && (

  <div className="generated-image-box">

    <img
      src={generatedImage}
      alt="Generated"
      className="generated-image"
    />

    <a
      href={generatedImage}
      download="vedai-image.png"
      className="download-btn"
    >
      Download Image
    </a>

  </div>

)}

<div>
  {!cameraOn ? (
    <button onClick={startCamera}>
      📷 Start Camera
    </button>
  ) : (
    <button onClick={stopCamera}>
      ❌ Stop Camera
    </button>
  )}

  <video
  ref={videoRef}
  autoPlay
  playsInline
  style={{
    width: "100%",
    maxWidth: "400px",
    marginTop: "10px",
    borderRadius: "12px",
    transform: `rotate(${rotation}deg)`
  }}
/>

  <canvas
    ref={canvasRef}
    style={{ display: "none" }}
  />

  <input
  type="text"
  placeholder="Ask camera something... (e.g. What is this?)"
  value={cameraQuestion}
  onChange={(e) => setCameraQuestion(e.target.value)}
/>

  <button
  onClick={askCamera}
  disabled={!cameraQuestion.trim()}
>
  🎤 Ask Camera
</button>

<button
  onClick={startCameraVoice}
>
  🎙️ Speak To Camera
</button>

{/* ADD THIS BELOW */}
<button
  onClick={() => {
    const newMode =
      facingMode === "environment"
        ? "user"
        : "environment";

    setFacingMode(newMode);

    stopCamera();
    setTimeout(() => {
      startCamera();
    }, 300);
  }}
>
  🔄 Switch Camera
</button>

{/* 🔥 3.2 ROTATE BUTTON (ADD HERE) */}
<button
  onClick={() => {
    setRotation((prev) => (prev + 90) % 360);
  }}
>
  🔄 Rotate View
</button>
</div>

{visionResult && (
  <div
    style={{
      marginTop: "10px",
      padding: "12px",
      background: "#111827",   // dark background
      color: "#e5e7eb",        // light readable text
      borderRadius: "12px",
      border: "1px solid #334155",
      whiteSpace: "pre-wrap"
    }}
  >
    {visionResult}
  </div>
)}

  </div> 
)}

        {/* CHAT AREA */}
        <div className="chat-area">

          {messages.map(
            (
              msg,
              index
            ) => (

              <div
                key={index}
                className={
                  msg.role ===
                  "user"
                    ? "message user"
                    : "message ai"
                }
              >
                {
                  msg.content
                }
              </div>

            )
          )}

          {loading && (

            <div className="message ai">
              VedAI is thinking...
            </div>

          )}

          {/* LIMIT WARNING */}
          {planInfo &&
            planInfo.remaining <=
              1 && (

              <div className="limit-warning">

                ⚠️ Your daily AI limit is almost finished.

                Upgrade to Pro or Ultra for uninterrupted access.

              </div>

            )}

          <div
            ref={
              messagesEndRef
            }
          />

        </div>

 {/* 🧠 MEMORY MODAL */}
{showMemory && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.6)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999999,
    }}
    onClick={() => setShowMemory(false)}
  >
    <div
      style={{
        width: "400px",
        maxHeight: "80vh",
        background: "#374151",
        borderRadius: "12px",
        padding: "20px",
        overflowY: "auto",
        color: "#fff",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <h2>🧠 VedAI Memory</h2>

      {memoryList?.length ? (
  memoryList.map((m, i) => (
    <div key={i} style={{ marginBottom: "10px" }}>
      <div>📌 {m.type || "memory"}</div>
      <div>
        {m.text ||
         m.content ||
         JSON.stringify(m)}
      </div>
    </div>
  ))
) : (
  <p>🧠 No memory found</p>
)}
    </div>
  </div>
)}

{/* INPUT AREA */}
<div className="input-area">
  <input
    type="text"
    placeholder="Ask VedAI anything..."
    value={message}
    onChange={(e) => setMessage(e.target.value)}
    onKeyDown={(e) => {
      if (e.key === "Enter") sendMessage();
    }}
  />

  <div className="input-buttons">
    <button className="mic-btn" onClick={startListening}>
      {listening ? "🎙️..." : "🎤"}
    </button>

    <button onClick={sendMessage}>Send</button>
  </div>
</div>

      </div>

    </div>

}
    />

  </Routes>

</BrowserRouter>

  );
}
export default App;